module.exports = __webpack_public_path__ + "img/step-3.a0ffe8b3.png";